import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startSync } from './lib/sync';
import { pruneLocal } from './lib/store';
import './styles.css';

startSync();
void pruneLocal();

// Offline support needs a secure origin (HTTPS, or localhost during development).
if ('serviceWorker' in navigator && import.meta.env.PROD && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => console.warn('Service worker registration failed', err));
  });
}

createRoot(document.getElementById('root')!).render(<App />);
